import clsx from "./ui/index.module.css";
import { Logo } from "../../shared/logo/Logo";
import { Linked } from "../../shared/Linked/Linked";

import { ReactComponent as FaceBook } from "../../assets/icons/facebook.svg";
import { ReactComponent as Instagram } from "../../assets/icons/instagram.svg";
import { ReactComponent as Telegram } from "../../assets/icons/telegram.svg";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className={`${clsx.footer} container`}>
  {/* LEFT COLUMN */}
  <div className={clsx.column}>
    <Linked onClick={() => navigate("/browse")} $size="18px">
      Browse apartments
    </Linked>

    <Linked
      onClick={() => {
        navigate("/how_it_works");
        window.scrollTo({ top: 0, behavior: "smooth" });
      }}
      $size="18px"
    >
      How it works
    </Linked>

    <Linked
      onClick={() => {
        navigate("/blog");
        window.scrollTo({ top: 0, behavior: "smooth" });
      }}
      $size="18px"
    >
      Blog
    </Linked>
  </div>

  {/* CENTER COLUMN */}
  <div className={clsx.columnCenter}>
    <div>FS COMMUNITY LTD</div>
    <div>partnership@flatsharingcommunity.com</div>

    <div className={clsx.socials}>
  <a
    href="https://www.instagram.com/flatsharing_community"
    target="_blank"
    rel="noopener noreferrer"
  >
    <Instagram />
  </a>

  <a
    href="https://t.me/DlyaSvoihBot?start=website"
    target="_blank"
    rel="noopener noreferrer"
  >
    <Telegram />
  </a>
</div>
  </div>

  {/* RIGHT COLUMN */}
  <div className={clsx.column}>
    <Linked
      target="_blank"
      href="https://flatsharingcommunity.com/terms.html"
      $size="16px"
    >
      Terms of Service
    </Linked>

    <Linked
      target="_blank"
      href="https://flatsharingcommunity.com/privacy_policy.html"
      $size="16px"
    >
      Privacy Policy
    </Linked>

    <Linked
      target="_blank"
      href="https://flatsharingcommunity.com/subscriptiom_terms.html"
      $size="16px"
    >
      Subscription Terms
    </Linked>

    <Linked
      target="_blank"
      href="https://flatsharingcommunity.com/money_back_policy.html"
      $size="16px"
    >
      Money Back Policy
    </Linked>
  </div>
</footer>
  );
};

export default Footer;
